import Vue from 'vue'

// Usage:
//
// * default
// $guard()(async () {
//   await api.get(...)
// })
// this will check this.loading to prevent duplicate call. and handle error with default handler
//
// * use custom error handler
// $guard()(async () {
//   await api.get(...)
// }, e => ...)
//
// * specify prop
// $guard('uploading')(async () {
//   await api.get(...)
// })
// will check this.uploading
//
// * specify scope
// $guard(imageItem)(async () {
//   await api.get(...)
// })
// will check imageItem.loading
//
// * specify scope and prop
// $guard(imageItem, 'uploading')(async () {
//   await api.get(...)
// })
// will check imageItem.uploading

export function guard (scope, prop = 'loading') {
  if (typeof scope === 'string') {
    prop = scope
    scope = null
  }
  scope = scope || this
  if (scope[prop] == null) {
    // make scope[prop] reactive
    Vue.set(scope, prop, false)
  }
  return async (func, errorHandler = handleError) => {
    // to prevent duplicate call
    if (scope[prop]) return
    try {
      scope[prop] = true
      await func()
    } catch (e) {
      // handle error
      errorHandler(e)
    } finally {
      scope[prop] = false
    }
  }
}

export const getErrorMessage = e => {
  if (e) {
    if (e.code > 0) {
      if (e.message === 'Auth Failed!') {
        return '授权失败'
      } else if (e.message === 'Inactivated!') {
        return '账户未激活'
      }
    } else if (e.statusInfo) {
      return e.statusInfo
    } else if (e.error_info) {
      return e.error_info
    }
  }
  return '程序出了点异常，正在加班修复中…'
}

export const handleError = e => {
  const message = getErrorMessage(e)
  Vue.prototype.$message.error(message)
  if (e.stack) console.error(e)
}

export default {
  guard,
  handleError,
  getErrorMessage,
}
